import { BUTTON_G_FIELD_V1 } from '../type_name'
import { VBtn } from 'vuetify/lib'
const default_key = {
    depressed: true,
    small: true
}
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: BUTTON_G_FIELD_V1,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        },
        index: {
            type: Number,
        },
        target: {
            type: Object,
        }
    },
    computed: {
        valueHandle() {
            const { buttons, handleButtons } = this.header 
            const clone_buttons = handleButtons ? handleButtons(buttons, this.target, this.header, this.index) : buttons
            return clone_buttons.map(item => {
                const { text, callback, style = {}, _text, ...other } = (item || {})
                const style_c = {
                    margin: '0px 5px',
                    ...style
                }
                return <VBtn
                 style={style_c}
                 props={{
                    ...default_key,
                    ...other,
                    text: _text
                }}
                on-click={() => {
                    callback && callback(this.target, this.header, this.index)
                }}
                >{text}</VBtn>
            })
        }
    },
    methods: {

    },
    render() {
        return <div>
            {this.valueHandle}
        </div> 
    }
}